/**
 * Formatting for the AI admin screens (VH-280): cost in US dollars (the providers bill
 * in dollars), response times, rates. Locale-aware so the German screen uses commas.
 */

/** Dollars with enough decimals that a fraction of a cent per call is still visible. */
export function formatUsd(value, locale = 'en') {
  if (value == null || !Number.isFinite(Number(value))) return '–'
  const n = Number(value)
  const digits = n !== 0 && Math.abs(n) < 0.01 ? 4 : 2
  return new Intl.NumberFormat(locale, {
    style: 'currency', currency: 'USD', minimumFractionDigits: digits, maximumFractionDigits: digits,
  }).format(n)
}

/** Milliseconds as seconds with one decimal ("1.2 s"); under a second stays in ms. */
export function formatMs(ms, locale = 'en') {
  if (ms == null) return '–'
  if (ms < 1000) return `${new Intl.NumberFormat(locale).format(Math.round(ms))} ms`
  return `${new Intl.NumberFormat(locale, { maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(ms / 1000)} s`
}

/** A 0–1 rate as a whole percentage. */
export function formatRate(rate, locale = 'en') {
  if (rate == null) return '–'
  return new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 0 }).format(rate)
}

/** A model name with the "retiring" tag when OpenAI has announced its end. */
export function modelLabel(model, retiring, tag) {
  return retiring.has(model) ? `${model} — ${tag}` : model
}
